import { useCallback, useEffect } from 'react';
// routes
import { paths } from '@routes/paths';
//
import { useAuthContext } from '../hooks';
import { useRouter, useSearchParams } from '@routes/hooks';
import React from "react";

type Props = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: Props) {
  const router = useRouter();

  const searchParams = useSearchParams();

  const returnTo = paths.patient.root;

  const { authenticated } = useAuthContext();

  const check = useCallback(() => {
    if (authenticated) {
      router.replace(returnTo);
    }
  }, [authenticated, returnTo, router]);

  useEffect(() => {

    check();
  }, [check]);

  return <>{children}</>;
}
